import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const TimeTrackingWidget: WidgetRegistryEntry = {
  name: "TimeTracking",
  component: () => import("./time-tracking-widget.component").then((m) => m.TimeTrackingWidgetComponent),
  configuration: () => import("./configuration").then((m) => m.TimeTrackingWidgetConfiguration)
};
